// F-O — AI usage meter query. Short staleTime: the meter moves whenever
// anyone generates narration, and the screen should reflect a top-up
// grant soon after the dev team runs the CLI (no restart involved).

import { useQuery } from "@tanstack/react-query";
import { AiUsage, getAiUsage } from "../aiUsage";

export const aiUsageKey = ["ai-usage"] as const;

export function useAiUsage() {
  return useQuery<AiUsage>({
    queryKey: aiUsageKey,
    queryFn: getAiUsage,
    staleTime: 30_000,
    refetchOnWindowFocus: true,
  });
}
